import type { RouteRecordRaw } from 'vue-router'

export const partnerRoutes: RouteRecordRaw = {
  path: '/:lang?/partners/',
  props: (route) => ({ lang: route.params.lang || 'en' }),
  component: () => import('@/Partners/layouts/DefaultLayout.vue'),
  children: [
    {
      path: '',
      name: 'partners-overview',
      component: () => import('@/Partners/views/OverviewVIew/OverviewView.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Partners', child: 'Become a partner' }
      }
    },
    {
      path: 'ib-portal/',
      name: 'ib-portal',
      component: () => import('@/Partners/views/IBPortalView/IBPortalView.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Partners', child: 'IB Portal' }
      }
    }
  ]
}
